import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _cr from './_cr';

import { a } from './_cmABT';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';

export type tLineCz = {
  boxStlz: _ht.dz,
  cellCs: BoxC.tBoxCz[]
};

export type tGridCz = {
  abtz?: _ht.dz, 
  boxStlz: _ht.dz,
  lineCs: tLineCz[],
  msgCz: TextC.tTextCz,
};

const $grtAbtz = (pz?: {
  type?: _ht.s,
  br?: _ht.n,
  dh?: _ht.s,
  f?: _ht.n,
  fd?: _ht.s,
  fw?: _ht.s,
  mb?: _ht.n,
  p?: _ht.n,
  sc?: _ht.s,
}) => {
  const _br = pz?.br ?? 0;
  const _dh = pz?.dh ?? 'n';
  const _f = pz?.f ?? 'n';
  const _fd = pz?.fd ?? 'rss';
  const _fw = pz?.fw ?? 'n';
  const _mb = pz?.mb ?? 0;
  const _p = pz?.p ?? 0;
  const _sc = pz?.sc ?? 't';
  switch (pz?.type) {
    case 'nml': 
    default:
      return {
//        boxStlz: a(`dw/f dh/${_dh} fd/css pt/${_mb}`),
        boxStlz: a(`br/${_br} dw/f dh/${_dh} fd/css pt/${_mb + _p} pb/${_p} ph/${_p} sc/${_sc}`),
        lineCz: ( _lineIdx: _ht.n ) => ({
          boxStlz: a(`dw/f fd/${_fd}`),
          cellCz: ( _cellIdx: _ht.n ) => ({
            boxStlz: a(`f/${_f} fd/ccc mb/${_mb} fw/${_fw}`),
          })
        })
      }
  }
};


export const N = (pz: tGridCz) => {

  const _abtz = $grtAbtz(pz.abtz);

  const _clds = [] as _ht.ls;

  pz.lineCs?.filter(( _linez: _ht.dz ) => _hm.f(_linez)).map( ( _linez: _ht.dz, _lineIdx: _ht.n ) => {

    const _lineAbtz = _abtz.lineCz ? _abtz.lineCz(_lineIdx) : null;

    const _lines = [] as _ht.ls;
    _linez?.cellCs?.map( (_cellCz: _ht.dz, _cellIdx: _ht.n) => {
      if (_cellCz) {
        _lines.push(
          _cr.c(BoxC.N, {
            key: _cellIdx,
            ... _cellCz,
            boxStlz: {
              ... _lineAbtz?.cellCz(_cellIdx)?.boxStlz,
              ... _cellCz?.boxStlz,
            },
          })
        );
      }
    });
    _clds.push(
      _cr.c(BoxC.N, {
        key: _lineIdx,
        boxStlz: {
          ... _lineAbtz?.boxStlz,
          ... _linez.boxStlz,
        },
        boxClds: _lines
      })
    );

  });

  if (!_hm.f(_clds) && pz.msgCz) {
    _clds.push(
      _cr.c(TextC.N, {
        key: -10,
        ... pz.msgCz,
      })
    )
  }

  return (
    _cr.c(BoxC.N, {
      key: 'Tbl.root',
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz
      },
      boxClds: _clds, 
    })
  )
};
